import AntdInput from '@deprecated-ui/common/Input';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

const SearchInput = styled(AntdInput)`
  border: 1px solid ${color.downgray};
  border-radius: 4px;

  :hover {
    border-color: ${color.downgray} !important;
  }

  ::placeholder {
    font-family: var(--font-bold) !important;
    color: #E3E3E3 !important;
  }

  input::placeholder, input::-webkit-input-placeholder {
    color: #E4E4E4 !important;
  }

  .ant-input-prefix {
    margin-right: 10px
  }

  .ant-input-clear-icon {
    display: flex;
  }
`;

const EmojiPickerWrapper = styled.div`
  height: 320px;
  overflow: scroll;
`;

const EmojiHeaderContainer = styled.div`
  padding: 0 15px;
`;

const EmojiCategoryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  .active-category {
    border-bottom: 2px solid #00ab6b;
  }
`;

const EmojiCategoryItem = styled.button.attrs({
  type: 'button',
})`
  background: transparent;
  border: none;
  outline: none;
  width: 36px;
  height: 42px;
  cursor: pointer;

  :hover {
    background: transparent;
  }
`;

const EmojiListContainer = styled.div`
  height: 198px;
  overflow-y: auto;
  padding: 0 15px;
`;

const EmojiListSection = styled.section`
  > p {
    text-transform: capitalize;
  }
`;

const EmojiItem = styled.button.attrs({
  type: 'button',
})`
  margin-right: 12.63px;
  margin-bottom: 20px;
  border-radius: 6px;
  background-color: transparent;
  outline: none;
  border: none;
  width: 32px;
  height: 32px;
  padding: 0;
  cursor: pointer;

  span {
    font-size: 32px;
    line-height: 32px;
    margin: 0;
    padding: 0;
  }
`;

const NoRecentEmoji = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 170px;
`;

export {
  EmojiPickerWrapper,
  EmojiHeaderContainer,
  EmojiCategoryContainer,
  EmojiCategoryItem,
  EmojiListContainer,
  EmojiListSection,
  EmojiItem,
  SearchInput,
  NoRecentEmoji,
};
